/* eslint-disable react-refresh/only-export-components */
import { Card, BlockStack, Text, Checkbox, Button } from "@medentic/polaris-react";
import { LanguageIcon } from "@medentic/polaris-icons";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { setSelectedLanguages } from "../model/eventSlice";
import { RootState } from "@app/store/store";
import useLanguages from "@shared/hooks/common/useLanguages";

interface TranslationsCardProps {
  translationsExpanded: boolean;
  setTranslationsExpanded: (expanded: boolean) => void;
  entityType: TranslationsEntityType;
}

export enum TranslationsEntityType {
  EVENT = "event",
  INSTRUCTOR = "instructor",
  BRAND = "brand",
}

export default function TranslationsCard({
  translationsExpanded,
  setTranslationsExpanded,
  entityType,
}: TranslationsCardProps) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const selectedLanguages = useSelector(
    (state: RootState) => state.event.selectedLanguages
  );
  const { languages = [] } = useLanguages();

  const translationKey =
    entityType === TranslationsEntityType.EVENT
      ? "eventDetails.sidebar.eventTranslations"
      : "instructorDetails.translations.title";

  const translateButtonKey =
    entityType === TranslationsEntityType.EVENT
      ? "eventDetails.sidebar.translate"
      : "instructorDetails.translations.translateContent";

  return (
    <Card>
      <BlockStack gap="200">
        <Text as="h3" variant="headingMd">
          {t(translationKey)}
        </Text>

        {languages
          .filter((language) => language.supported)
          .map((language) => (
            <Checkbox
              key={language.iso}
              label={language.localLabel}
              checked={selectedLanguages.includes(language.iso)}
              onChange={(checked) => {
                const newLocales = [...selectedLanguages];
                if (checked) {
                  newLocales.push(language.iso);
                } else if (selectedLanguages.length > 1) {
                  newLocales.splice(newLocales.indexOf(language.iso), 1);
                }
                dispatch(setSelectedLanguages(newLocales));
              }}
            />
          ))}

        <Button
          icon={LanguageIcon}
          onClick={() => setTranslationsExpanded(!translationsExpanded)}
          fullWidth
        >
          {t(translateButtonKey)}
        </Button>
      </BlockStack>
    </Card>
  );
}
